import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import storage from "../common/utils/storage";

var u = navigator.userAgent;
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
if (isiOS && !window.entryLink) {
  window.entryLink = encodeURIComponent(window.location.href.split("#")[0]);
}

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
}

const routes = [
  {
    path: "/",
    redirect: 'home'
  },
  {
    path: "/authorize",
    name: "Authorize",
    component: () => import("@/views/Authorize/Authorize"),
    meta: {
      navShow: false,
      isLogin: false,
      Title: '授权'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/login.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/dahuilist',
    name: 'dahuilist',
    component: () => import('../views/home/meetingList.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/upload',
    name: 'upload',
    component: () => import('../views/mine/upload.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/mine',
    name: 'mine',
    component: () => import('../views/mine/mine.vue'),
    meta: {
      navShow: true,
      isLogin: false,
      Title: '我的'
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/home/index.vue'),
    meta: {
      navShow: true,
      isLogin: false,
      Title: '首页'
    }
  },
  {
    path: '/subjectList',
    name: 'SubjectList',
    component: () => import('../views/subject/list.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/informationDetails',
    name: 'InformationDetails',
    component: () => import('../views/information/details.vue'),
    meta: {
      navShow: false,
      isLogin: true,
      title: '华肤荟'
    }
  },
  {
    path: '/myidentity',
    name: 'myidentity',
    component: () => import('../views/mine/myidentity.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/getidentity',
    name: 'getidentity',
    component: () => import('../views/mine/getidentity.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/compinfo',
    name: 'compinfo',
    component: () => import('../views/login/compinfo.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/renzhenginfo',
    name: 'renzhenginfo',
    component: () => import('../views/login/renzhenginfo.vue'),
    meta: {
      navShow: false,
      isLogin: true,
      title: '华肤荟'
    }
  },
  {
    path: '/infocomp',
    name: 'infocomp',
    component: () => import('../views/login/infocomp.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/question',
    name: 'Question',
    component: () => import('../views/Question/index.vue'),
    meta: {
      navShow: false,
      isLogin: true,
      title: '华肤荟'
    }
  },
  {
    path: '/newrenzheng',
    name: 'newrenzheng',
    component: () => import('../views/ACMED/newrenzheng.vue'),
    meta: {
      navShow: false,
      isLogin: true,
      title: '加入ACMED'
    }
  },
  {
    path: '/newok',
    name: 'newok',
    component: () => import('../views/ACMED/newok.vue'),
    meta: {
      navShow: false,
      isLogin: true,
      title: '加入ACMED'
    }
  },
  {
    path: '/newpayok',
    name: 'newpayok',
    component: () => import('../views/ACMED/newpayok.vue'),
    meta: {
      navShow: false,
      isLogin: true,
      title: '加入ACMED'
    }
  },
  {
    path: '/liveList',
    name: 'liveList',
    component: () => import('../views/live/list.vue'),
    meta: {
      navShow: true,
      isLogin: true,
      title: '华肤荟'
    }
  },
  {
    path: '/liveztList',
    name: 'liveztList',
    component: () => import('../views/live/ztlist.vue'),
    meta: {
      navShow: true,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/ztmoreList',
    name: 'ztmoreList',
    component: () => import('../views/live/ztmoreList.vue'),
    meta: {
      navShow: true,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/program',
    name: 'program',
    component: () => import('../views/program/index.vue'),
    meta: {
      navShow: true,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/programvod',
    name: 'programvod',
    component: () => import('../views/program/programvod.vue'),
    meta: {
      navShow: true,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/ztmoreList',
    name: 'ztmoreList',
    component: () => import('../views/live/ztmoreList.vue'),
    meta: {
      navShow: true,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/live',
    name: 'Live',
    component: () => import('../views/live/index.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/obsLive',
    name: 'ObsLive',
    component: () => import('../views/live/obsLive.vue'),
    meta: {
      navShow: false,
      isLogin: true,
      title: '华肤荟'
    }
  },
  {
    path: '/AuthThird',
    name: 'AuthThird',
    component: () => import('../views/Authorize/AuthThird.vue'),
    meta: {
      navShow: false,
      isLogin: true,
      title: '华肤荟'
    }
  },
  {
    path: '/ACMED',
    name: 'ACMED',
    component: () => import('../views/ACMED/index.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: 'ACMED第一届学术年会'
    }
  },
  {
    path: '/CCDS',
    name: 'CCDS',
    component: () => import('../views/CCDS/index.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: 'CCDS第四届中国皮肤外科大会'
    }
  },
  {
    path: '/ccdswelcome',
    name: 'ccdswelcome',
    component: () => import('../views/CCDS/welcome.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: 'CCDS第四届中国皮肤外科大会',
    }
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: () => import('../views/ACMED/welcome.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: 'ACMED第一届学术年会'
    }
  },
  {
    path: '/regmeeting',
    name: 'regmeeting',
    component: () => import('../views/ACMED/regmeeting.vue'),
    meta: {
      navShow: false,
      isLogin: true,
      title: 'ACMED第一届学术年会'
    }
  },
  {
    path: '/ccdsregmeeting',
    name: 'ccdsregmeeting',
    component: () => import('../views/CCDS/regmeeting.vue'),
    meta: {
      navShow: false,
      isLogin: true,
      title: 'CCDS第四届中国皮肤外科大会'
    }
  },
  {
    path: '/ccdsinfo',
    name: 'ccdsinfo',
    component: () => import('../views/CCDS/info.vue'),
    meta: {
      navShow: false,
      isLogin: true,
      title: 'CCDS第四届中国皮肤外科大会'
    }
  },
  {
    path: '/baseinfo',
    name: 'baseinfo',
    component: () => import('../views/ACMED/baseinfo.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: 'ACMED第一届学术年会'
    }
  },
  {
    path: '/zuzhi',
    name: 'zuzhi',
    component: () => import('../views/ACMED/zuzhi.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: 'ACMED第一届学术年会'
    }
  },
  {
    path: '/tuiguang',
    name: 'tuiguang',
    component: () => import('../views/ACMED/tuiguang.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '加入ACMED'
    }
  },
  {
    path: '/ccdszuzhi',
    name: 'ccdszuzhi',
    component: () => import('../views/CCDS/zuzhi.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: 'CCDS第四届中国皮肤外科大会'
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ACMED/contact.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: 'ACMED第一届学术年会'
    }
  },
  {
    path: '/ccdscontact',
    name: 'ccdscontact',
    component: () => import('../views/CCDS/contact.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: 'CCDS第四届中国皮肤外科大会'
    }
  },
  {
    path: '/timeline',
    name: 'timeline',
    component: () => import('../views/ACMED/timeline.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: 'ACMED第一届学术年会'
    }
  },
  {
    path: '/ccdstimeline',
    name: 'ccdstimeline',
    component: () => import('../views/CCDS/timeline.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: 'CCDS第四届中国皮肤外科大会'
    }
  },
  {
    path: '/acmedmeetinginfo',
    name: 'acmedmeetinginfo',
    component: () => import('../views/ACMED/meetinginfo.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: 'ACMED第一届学术年会'
    }
  },
  {
    path: '/ccdsmeetinginfo',
    name: 'ccdsmeetinginfo',
    component: () => import('../views/CCDS/meetinginfo.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: 'CCDS第四届中国皮肤外科大会'
    }
  },
  {
    path: '/joinmeeting',
    name: 'joinmeeting',
    component: () => import('../views/ACMED/joinmeeting.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: 'ACMED第一届学术年会'
    }
  },
  {
    path: '/ccdsjoinmeeting',
    name: 'ccdsjoinmeeting',
    component: () => import('../views/CCDS/joinmeeting.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: 'CCDS第四届中国皮肤外科大会'
    }
  },
  {
    path: '/zhineng',
    name: 'zhineng',
    component: () => import('../views/ACMED/zhineng.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: 'ACMED第一届学术年会'
    }
  },
  {
    path: '/ccdszhineng',
    name: 'ccdszhineng',
    component: () => import('../views/CCDS/zhineng.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: 'CCDS第四届中国皮肤外科大会'
    }
  },
  {
    path: '/acmedzhibo',
    name: 'acmedzhibo',
    component: () => import('../views/ACMED/zhibo.vue'),
    meta: {
      navShow: false,
      isLogin: true,
      title: 'ACMED第一届学术年会'
    }
  },
  {
    path: '/ccdszhibo',
    name: 'ccdszhibo',
    component: () => import('../views/CCDS/zhibo.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: 'CCDS第四届中国皮肤外科大会'
    }
  },
  {
    path: '/jiaotong',
    name: 'jiaotong',
    component: () => import('../views/ACMED/jiaotong.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: 'ACMED第一届学术年会'
    }
  },
  {
    path: '/ccdsjiaotong',
    name: 'ccdsjiaotong',
    component: () => import('../views/CCDS/jiaotong.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: 'CCDS第四届中国皮肤外科大会'
    }
  },
  {
    path: '/downfile',
    name: 'downfile',
    component: () => import('../views/ACMED/downfile.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: 'ACMED第一届学术年会'
    }
  },
  {
    path: '/ccdsdownfile',
    name: 'ccdsdownfile',
    component: () => import('../views/CCDS/downfile.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: 'CCDS第四届中国皮肤外科大会'
    }
  },
  {
    path: '/uploadInfo',
    name: 'acmedUploadInfo',
    component: () => import('../views/ACMED/uploadInfo.vue'),
    meta: {
      navShow: false,
      isLogin: true,
      title: '加入ACMED'
    }
  },
  {
    path: '/newenterin',
    name: 'newenterin',
    component: () => import('../views/ACMED/newenterin.vue'),
    meta: {
      navShow: false,
      isLogin: true,
      title: '加入ACMED'
    }
  },
  {
    path: '/acmedonly',
    name: 'acmedonly',
    component: () => import('../views/ACMED/acmedonly.vue'),
    meta: {
      navShow: false,
      isLogin: true,
      title: '加入ACMED'
    }
  },
  {
    path: '/newenterdone',
    name: 'newenterdone',
    component: () => import('../views/ACMED/newenterdone.vue'),
    meta: {
      navShow: false,
      isLogin: true,
      title: '加入ACMED'
    }
  },
  {
    path: '/reviewInfo',
    name: 'acmedReviewInfo',
    component: () => import('../views/ACMED/reviewInfo.vue'),
    meta: {
      navShow: false,
      isLogin: true,
      title: '加入ACMED'
    }
  },
  {
    path: '/pay',
    name: 'acmedPay',
    component: () => import('../views/ACMED/pay.vue'),
    meta: {
      navShow: false,
      isLogin: true,
      title: '加入ACMED'
    }
  },
  {
    path: '/acmedUpload',
    name: 'acmedUpload',
    component: () => import('../views/ACMED/upload.vue'),
    meta: {
      navShow: false,
      isLogin: true,
      title: '加入ACMED'
    }
  },
  {
    path: '/classlist',
    name: 'classlist',
    component: () => import('../views/class/classlist.vue'),
    meta: {
      navShow: false,
      isLogin: true,
      title: '精品课程'
    }
  },
  {
    path: '/BJZL',
    name: 'BJZL',
    component: () => import('../views/BJZL/index.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '第九届北京肿瘤防治研究会年会暨第十九届绿荫沙龙学术年会'
    }
  },
  {
    path: '/bjwelcome',
    name: 'bjwelcome',
    component: () => import('../views/BJZL/welcome.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '第九届北京肿瘤防治研究会年会暨第十九届绿荫沙龙学术年会',
    }
  },
  {
    path: '/bjzhuanjia',
    name: 'bjzhuanjia',
    component: () => import('../views/BJZL/zhuanjia.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '第九届北京肿瘤防治研究会年会暨第十九届绿荫沙龙学术年会',
    }
  },
  {
    path: '/bjinfo',
    name: 'bjinfo',
    component: () => import('../views/BJZL/info.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '第九届北京肿瘤防治研究会年会暨第十九届绿荫沙龙学术年会',
    }
  },
  {
    path: '/bjcontact',
    name: 'bjcontact',
    component: () => import('../views/BJZL/contact.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '第九届北京肿瘤防治研究会年会暨第十九届绿荫沙龙学术年会',
    }
  },
  {
    path: '/bjdaohang',
    name: 'bjdaohang',
    component: () => import('../views/BJZL/daohang.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '第九届北京肿瘤防治研究会年会暨第十九届绿荫沙龙学术年会',
    }
  },
  {
    path: '/bjjiansuo',
    name: 'bjjiansuo',
    component: () => import('../views/BJZL/jiansuo.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '第九届北京肿瘤防治研究会年会暨第十九届绿荫沙龙学术年会',
    }
  },
  {
    path: '/bjlist',
    name: 'bjlist',
    component: () => import('../views/BJZL/list.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '第九届北京肿瘤防治研究会年会暨第十九届绿荫沙龙学术年会',
    }
  },
  {
    path: '/bjmeeting',
    name: 'bjmeeting',
    component: () => import('../views/BJZL/meeting.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '第九届北京肿瘤防治研究会年会暨第十九届绿荫沙龙学术年会',
    }
  },
  {
    path: '/section',
    name: 'section',
    component: () => import('../views/section/index.vue'),
    meta: {
      navShow: true,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/sectionlist',
    name: 'sectionlist',
    component: () => import('../views/section/sectionlist.vue'),
    meta: {
      navShow: true,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/sectionvdlist',
    name: 'sectionvdlist',
    component: () => import('../views/section/vdlist.vue'),
    meta: {
      navShow: true,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/sectionlivelist',
    name: 'sectionlivelist',
    component: () => import('../views/section/livelist.vue'),
    meta: {
      navShow: true,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/sectionctlist',
    name: 'sectionctlist',
    component: () => import('../views/section/ctlist.vue'),
    meta: {
      navShow: true,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/grouplist',
    name: 'grouplist',
    component: () => import('../views/mine/grouplist.vue'),
    meta: {
      navShow: true,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/groupcheck',
    name: 'groupcheck',
    component: () => import('../views/mine/groupcheck.vue'),
    meta: {
      navShow: true,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/newscheck',
    name: 'newscheck',
    component: () => import('../views/mine/newscheck.vue'),
    meta: {
      navShow: true,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/custom',
    name: 'custom',
    component: () => import('../views/custom/index.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/customimg',
    name: 'customimg',
    component: () => import('../views/custom/customimg.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/custommap',
    name: 'custommap',
    component: () => import('../views/custom/custommap.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/customtextarea',
    name: 'customtextarea',
    component: () => import('../views/custom/customtextarea.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/customtimeline',
    name: 'customtimeline',
    component: () => import('../views/custom/timeline.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/customjiansuo',
    name: 'customjiansuo',
    component: () => import('../views/custom/jiansuo.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/custommeeting',
    name: 'custommeeting',
    component: () => import('../views/custom/meeting.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/custommeetinginfo',
    name: 'custommeetinginfo',
    component: () => import('../views/custom/meetinginfo.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '华肤荟'
    }
  },
  {
    path: '/customzj',
    name: 'customzj',
    component: () => import('../views/custom/customzj.vue'),
    meta: {
      navShow: false,
      isLogin: false,
      title: '华肤荟'
    }
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (to.path != '/authorize') {
    storage.setStore('lastPath', to.fullPath);
  }

  if (to.path != '/authorize' && to.path != '/login' && to.path != '/compinfo') {
    sessionStorage.setItem("redirectUrl", to.fullPath);
  }

  let Openid = null;
  if (process.env.NODE_ENV == 'development') {
    Openid = store.state.Openid;
    const userInfo = {
      CreateTime: "2025-02-17T17:48:53.473",
      CreateUser: "系统",
      CreateUserId: 0,
      CreateUserType: 0,
      Head: "https://thirdwx.qlogo.cn/mmopen/vi_32/pj9S5BibuYrwZ9DhDjFndKicvdicK9iaibJdAPbIXhJfuhACdUhtwcBromCPNxNxutkfKchDHMDv7QOb8NoXiaxsaib2Q/132",
      Id: 2,
      IdCode: "7ec336e5-5bd8-4c52-8b80-808b8dae91f7",
      IsDeleted: false,
      LastLoginTime: "2025-02-18T10:36:47.2388217+08:00",
      Mobile: null,
      NickName: "D",
      OpenId: "oZ4c66iJ2D0u165oHhhgjyewMVdY",
      Status: 30,
      Token: "fcd4938b934040e8b614c5120003a741",
      UnionId: "oB3w055Cgo8GW5Y1t35SMsAaCbfY",
      UpdateTime: "2025-02-18T10:36:47.2388217+08:00",
      UpdateUser: "系统",
      UpdateUserId: 0,
      UpdateUserType: 0
    };
    store.dispatch('setUserInfo', { userInfo: userInfo });
    sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
    sessionStorage.setItem('Token', 'fcd4938b934040e8b614c5120003a741');
  } else {
    Openid = sessionStorage.getItem("Openid");
    if (Openid) {
      store.commit('updateOpenid', Openid);
    }
  }

  if (!Openid && to.path != '/authorize') {
    storage.setStore('scope', 'snsapi_base');
    next({
      path: '/authorize',
      query: { scope: 'snsapi_base' }
    })
  } else {
    //记录页面日志
    let param = {
      BPType: 1,
      Name: to.name,
      TCode: '',
      Url: to.path,
      FullUrl: to.fullPath,
    }
    Vue.prototype.$axios.post('/api/api/web/BuriedPoint/AddBP', param);
    //判断注册状态，跳转对应页面
    if (to.meta.isLogin) {
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
      if (userInfo && userInfo.Status < 30) {
        next('/login');
      } else if (userInfo && userInfo.Status < 40) {
        next('/compinfo');
      } else {
        next();
      }
    } else {
      next();
    }
  }
})

router.afterEach((to, from) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = '';
  }
})

export default router;
